import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import {
  AddEmailBulkSendRecipientsDocument,
  type AddEmailBulkSendRecipientsMutation,
  type AddEmailBulkSendRecipientsMutationVariables,
  CancelEmailBulkSendDocument,
  type CancelEmailBulkSendMutation,
  type CancelEmailBulkSendMutationVariables,
  ChangeEmailBulkSendTimeDocument,
  type ChangeEmailBulkSendTimeMutation,
  type ChangeEmailBulkSendTimeMutationVariables,
  RemoveEmailBulkSendRecipientsDocument,
  type RemoveEmailBulkSendRecipientsMutation,
  type RemoveEmailBulkSendRecipientsMutationVariables,
  SendEmailBulkSendDocument,
  type SendEmailBulkSendMutation,
  type SendEmailBulkSendMutationVariables,
  SendRestOfEmailBulkSendDocument,
  type SendRestOfEmailBulkSendMutation,
  type SendRestOfEmailBulkSendMutationVariables
} from '~/api/graphql';

/** Refetches what's on screen too, since every waiting row of the batch changes. */
export const cancelEmailBulkSend = (variables: CancelEmailBulkSendMutationVariables) =>
  mutateData<CancelEmailBulkSendMutation, CancelEmailBulkSendMutationVariables>(client, {
    mutation: CancelEmailBulkSendDocument,
    variables,
    refetchQueries: 'active'
  });

/** Refetches what's on screen too, since every waiting row of the batch is replaced. */
export const changeEmailBulkSendTime = (variables: ChangeEmailBulkSendTimeMutationVariables) =>
  mutateData<ChangeEmailBulkSendTimeMutation, ChangeEmailBulkSendTimeMutationVariables>(client, {
    mutation: ChangeEmailBulkSendTimeDocument,
    variables,
    refetchQueries: 'active'
  });

export const sendEmailBulkSend = (variables: SendEmailBulkSendMutationVariables) =>
  mutateData<SendEmailBulkSendMutation, SendEmailBulkSendMutationVariables>(client, {
    mutation: SendEmailBulkSendDocument,
    variables
  });

export const sendRestOfEmailBulkSend = (variables: SendRestOfEmailBulkSendMutationVariables) =>
  mutateData<SendRestOfEmailBulkSendMutation, SendRestOfEmailBulkSendMutationVariables>(client, {
    mutation: SendRestOfEmailBulkSendDocument,
    variables
  });

export const addEmailBulkSendRecipients = (
  variables: AddEmailBulkSendRecipientsMutationVariables
) =>
  mutateData<AddEmailBulkSendRecipientsMutation, AddEmailBulkSendRecipientsMutationVariables>(
    client,
    { mutation: AddEmailBulkSendRecipientsDocument, variables }
  );

export const removeEmailBulkSendRecipients = (
  variables: RemoveEmailBulkSendRecipientsMutationVariables
) =>
  mutateData<RemoveEmailBulkSendRecipientsMutation, RemoveEmailBulkSendRecipientsMutationVariables>(
    client,
    { mutation: RemoveEmailBulkSendRecipientsDocument, variables }
  );
